interface isStrongPasswordProps {
  isPassValid: boolean[];
  passRequirement: boolean[];
}

export const isStrongPassword = (password: string): isStrongPasswordProps => {
  // Define the regular expressions for each required component
  const hasLowercase = /[a-z]/;
  const hasUppercase = /[A-Z]/;
  const hasNumber = /[0-9]/;
  const hasSymbol = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

  // Check if the password meets all the criteria
  const isLongEnough = password.length >= 10;
  const hasLowercaseLetter = hasLowercase.test(password);
  const hasUppercaseLetter = hasUppercase.test(password);
  const hasNumberCharacter = hasNumber.test(password);
  const hasSymbolCharacter = hasSymbol.test(password);

  // Return values in array of object
  return {
    isPassValid: [
      isLongEnough,
      isLongEnough,
      hasLowercaseLetter,
      hasLowercaseLetter,
      hasUppercaseLetter,
      hasUppercaseLetter,
      hasNumberCharacter,
      hasNumberCharacter,
      hasSymbolCharacter,
      hasSymbolCharacter,
    ],
    passRequirement: [
      isLongEnough,
      hasLowercaseLetter,
      hasUppercaseLetter,
      hasNumberCharacter,
      hasSymbolCharacter,
    ],
  };
};

export const checkIsNameValid = (name: string) => {
  const nameRegEx = /^[A-Za-z][a-zA-Z'-]*(?:\s+[A-Za-z][a-zA-Z'-]*)*$/;

  return nameRegEx.test(name);
};

export const checkIsEmailValid = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
};

// function to sort truthy values first in an array
export const arrElementCompare = (a: boolean, b: boolean) => {
  if (a && !b) return -1;
  if (!a && b) return 1;
  return 0;
};

export const linkedInValidate = (url: string) => {
  const linkedinUrlRegex =
    /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school)\/([a-zA-Z0-9_-]+\/?)$/;
  return linkedinUrlRegex.test(url);
};

export function isValidUrl(url: string): boolean {
  const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return urlPattern.test(url.trim());
}
